import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/Error';

const ErrorHolder = ({ text }) => {
  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <ErrorIcon
          sx={{ fontSize: 72, marginTop: '120px', marginBottom: '1rem' }}
        />
        <Typography sx={{ fontSize: '1rem' }}>{text}</Typography>
      </Box>
    </>
  );
};

ErrorHolder.propTypes = {
  text: PropTypes.string,
};

ErrorHolder.defaultProps = {
  text: '錯誤',
};

export default ErrorHolder;
